var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManualAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / manual_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.8982465%",
    y1: "91.566132%",
    x2: "39.9596462%",
    y2: "19.6777344%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8B8B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676767",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-manual_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_MainApp_Icon-/-manual_app_tile",
    transform: "translate(11.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BOD",
    transform: "translate(0.587988, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 L12,88 L68,88 L68,0 L12,0 Z M44,63 L36,63 L36,34 L44,34 L44,63 Z M44,28 L36,28 L36,20 L44,20 L44,28 Z",
    id: "Page---Fill",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,1 L67,87 L13,87 L13,1 L67,1 Z M45,33 L35,33 L35,64 L45,64 L45,33 Z M45,19 L35,19 L35,29 L45,29 L45,19 Z",
    id: "Page---Border",
    strokeOpacity: 0.332167832,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L8,0 L8,0 L8,88 L3,88 C1.34314575,88 2.02906125e-16,86.6568542 0,85 L0,3 C-2.02906125e-16,1.34314575 1.34314575,-2.36017607e-15 3,0 Z",
    id: "Back---Fill",
    fill: "url(#linearGradient-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualAppTile);
export default __webpack_public_path__ + "static/media/manual_app_tile.1b000ef7cd4d8ba9ca605c3b885ff528.svg";
export { ForwardRef as ReactComponent };